var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaguewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09375 9.10434V13.6452C3.09375 15.308 3.09375 15.308 4.66523 16.3679L8.9868 18.8621C9.63549 19.2367 10.6953 19.2367 11.344 18.8621L15.6656 16.3679C17.2371 15.308 17.2371 15.308 17.2371 13.6452V9.10434C17.2371 7.4415 17.2371 7.4415 15.6656 6.38166L11.344 3.88739C10.6953 3.5128 9.63549 3.5128 8.9868 3.88739L4.66523 6.38166C3.09375 7.4415 3.09375 7.4415 3.09375 9.10434Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1908 6.00714V3.60423C15.1908 1.77693 14.2771 0.863281 12.4498 0.863281H7.88158C6.05428 0.863281 5.14062 1.77693 5.14062 3.60423V5.94318",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7392 9.07706L11.2599 9.89021C11.3422 10.0181 11.5249 10.146 11.662 10.1826L12.5939 10.4201C13.1695 10.5663 13.3248 11.0597 12.9502 11.5165L12.3381 12.2566C12.2467 12.3753 12.1736 12.5855 12.1827 12.7317L12.2376 13.691C12.2741 14.2849 11.8538 14.5864 11.3056 14.3671L10.4103 14.0108C10.2732 13.956 10.0448 13.956 9.90774 14.0108L9.01236 14.3671C8.46417 14.5864 8.04389 14.2757 8.08044 13.691L8.13526 12.7317C8.14439 12.5855 8.0713 12.3662 7.97994 12.2566L7.36779 11.5165C6.99319 11.0597 7.14852 10.5663 7.72412 10.4201L8.65604 10.1826C8.80222 10.146 8.98495 10.009 9.05805 9.89021L9.57883 9.07706C9.90774 8.58369 10.4194 8.58369 10.7392 9.07706Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaguewhite);
export default __webpack_public_path__ + "static/media/leaguewhite.9c0b2be9b1ca9a0a9889771588531a07.svg";
export { ForwardRef as ReactComponent };